/* eslint-disable */
import React, {useState} from "react";
import {Fab, makeStyles, Modal} from "@material-ui/core";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import SlideHover from "../video/SlideHover";
import styles from "./SlideIcon.module.css";

interface SlideIconProps {
    // ビデオID
    videoId: string
}

const useStyles = makeStyles({
    icon: {
        marginLeft: "5px",
        marginTop: "5px",
        backgroundColor: "rgb(255, 255, 255, 0.7)",
        '&:hover': {
            backgroundColor: "rgb(255, 255, 255, 0.9)",
       }
   },
    icon2: {
        marginLeft: "5px",
        marginTop: "5px",
        backgroundColor: "var(--gray-61)",
        '&:hover': {
            backgroundColor: "var(--gray-42)",
       }
   }
});

export default function SlideIcon({...props}:SlideIconProps) {

    const classes = useStyles();

    const [slideModal, setSlideModal] = useState(false);

    const OpenSlideModal = () => {
        console.log("OPEN")
        setSlideModal(true)
   }
    const CloseSlideModal = () => {
        setSlideModal(false);
   };

    return (
        <>
            <div className={styles.slideBtn}>
                {/* <Fab
                    variant="circular"
                    size="small"
                    onClick={OpenSlideModal}
                    className= {classes.icon}
                >
                    <LibraryBooksIcon />
                </Fab> */}
                <Fab
                    variant="circular"
                    size="small"
                    onClick={OpenSlideModal}
                    className= {classes.icon2}
                >
                    <LibraryBooksIcon style={{color: "var(--white)"}}/>
                </Fab>
                {/* <Fab
                    variant="circular"
                    size="small"
                    onClick={OpenSlideModal}
                    className= {classes.icon}
                    style={{border:"0.1mm solid var(--gray-61)"}}
                >
                    <LibraryBooksIcon style={{color: "var(--gray-61)"}}/>
                </Fab>
                <Fab
                    variant="circular"
                    size="small"
                    onClick={OpenSlideModal}
                    className= {classes.icon}
                    style={{border:"0.1mm solid var(--red)"}}
                >
                    <LibraryBooksIcon style={{color: "var(--gray-42)"}}/>
                </Fab>
                <Fab
                    variant="circular"
                    size="small"
                    onClick={OpenSlideModal}
                    className= {classes.icon}
                >
                    <LibraryBooksIcon style={{color: "var(--red)"}}/>
                </Fab> */}
            </div>
            <Modal
                open={slideModal}
                onClose={CloseSlideModal}
                className={styles.modal}
            >
                <SlideHover in={slideModal} videoId={props.videoId} onClose={CloseSlideModal}/>
            </Modal>
        </>
    );
}
